import {
  currentRoomPropOrder,
  otherRoomPropOrder,
  pushCurrentRoomPropOrder,
} from 'client/pc/store/lianmai/mask-pk';
import { debug, utils } from 'lib';
import { UiToast } from 'components';
import animate from 'widgets/functions/animation/animate';
import maskPkLib from '../mask-pk';

import forEach from 'lodash/forEach';

const log = debug.create('maskPk');

const handle = (socket) => {
  socket.on('mask.pk.first', (msg, { room }) => {
    room.update();
    maskPkLib.loadInfo();
  });

  socket.on('mask.pk.second', (msg) => {
    maskPkLib.loadInfo();
  });

  socket.on('mask.pk.third', (msg) => {
    maskPkLib.loadInfo();
  });

  socket.on('mask.pk.fourth', (msg, { room }) => {
    room.update();
    maskPkLib.loadInfo();
  });

  socket.on('mask.pk.star_value_update', (msg, { lianmai: { maskPk } }) => {
    msg.data.forEach((item) => {
      maskPk.info.mode_info.updatePkValue(item.self, item.pk_value);
    });

    // maskPkLib.loadInfo()
  });

  socket.on('mask.pk.match_tips', (msg, { room, lianmai: { maskPk } }) => {
    log('match_tips', maskPk.info.toJSON(), room.roomInfo.toJSON());

    UiToast.text('目前暂无匹配主播，请耐心等待或取消匹配');

    maskPkLib.loadInfo();
  });
  socket.on('mask.pk.match_cancel', (msg, { room, lianmai: { maskPk } }) => {
    log('match_cancel', maskPk.info.toJSON(), room.roomInfo.toJSON());

    UiToast.text(msg.data.msg || '匹配已取消');

    maskPkLib.loadInfo();
  });

  socket.on('mask.pk.crit.start', (msg, { room, lianmai: { maskPk } }) => {
    log('crit.start', maskPk.info.toJSON(), room.roomInfo.toJSON());
    maskPkLib.loadInfo();
  });

  socket.on('mask.pk.crit.end', (msg, { room, lianmai: { maskPk } }) => {
    log('crit.end', maskPk.info.toJSON(), room.roomInfo.toJSON());

    maskPkLib.loadInfo();
  });
  socket.on('year25_mask_pk_props', (msg, { room, lianmai: { maskPk } }) => {
    log('year25_mask_pk_props', maskPk.info.toJSON(), room.roomInfo.toJSON());

    // type = "start";
    // pk_info

    const isYwd = msg.data.pk_info.find((item) => {
      return item.room_id === 0 && item.prop_name === 'ywd';
    });

    if (msg.data.type === 'start' && isYwd) {
      animate.push({
        gift: {
          vap_url: 'https://img-photo.sumeme.com/swf/ywd44652.mp4',
          vap_config_url: 'https://img-photo.sumeme.com/swf/ywd45605.json',
          animate_pos: 0,
        },
      });
    }

    const { currentRoomInfo, otherRoomInfo } = maskPk.info.mode_info;

    msg.data.pk_info.forEach((item) => {
      if (item.prop_name && msg.data.type === 'start') {
        if (item.room_id === currentRoomInfo.room_id) {
          const isNewProp = currentRoomInfo.props[item.prop_name].remain === 0;
          if (isNewProp) {
            currentRoomPropOrder.splice(
              currentRoomPropOrder.findIndex((orderItem) => {
                return orderItem === item.prop_name;
              }),
              1,
            );
            currentRoomPropOrder.push(item.prop_name);

            console.log('prop currentRoomPropOrder', currentRoomPropOrder);
          }
        } else {
          const isNewProp = otherRoomInfo.props[item.prop_name].remain === 0;
          if (isNewProp) {
            otherRoomPropOrder.splice(
              otherRoomPropOrder.findIndex((orderItem) => {
                return orderItem === item.prop_name;
              }),
              1,
            );
            otherRoomPropOrder.unshift(item.prop_name);

            console.log('prop otherRoomPropOrder', otherRoomPropOrder);
          }
        }
      }
    });

    maskPkLib.loadInfo();
  });
};

export default handle;
